<style lang="scss">
.price-cell {
  max-width: 32rem;
  margin: auto;

  h1 {
    font-size: 7rem;
    font-family: 'Roboto', sans-serif;
    margin-right: 1rem;
  }

  .trend-percentage-wrapper {
    margin-left: 1rem;
    font-size: 5rem;
    font-weight: bold;
  }
}
</style>

<template>
  <div class="price-cell flex flex-row h-full justify-center items-center">
    <h2
      v-if="!hasData"
    >
      -
    </h2>
    <div
      v-if="hasData"
      class="w-3/5 text-right"
    >
      <h1>{{ priceData.value | formatPrice }}</h1>
    </div>
    <div
      v-if="hasData"
      class="w-2/5 text-left"
    >
      <v-trend-percentage
        :percentage="priceData.difference"
        :show-absolute="true"
        :show-percentage-icon="false"
        arrow-width="30px"
      />
    </div>
  </div>
</template>

<script>
import VTrendPercentage from '@/components/VTrendPercentage/VTrendPercentage';

export default {
  name: 'PriceCell',
  components: {
    VTrendPercentage,
  },
  props: {
    priceData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    hasData() {
      return this.priceData !== null;
    },
  },
};
</script>
